const eventPrefix = 'absa.access.rum';
export const eventTypes = {
    fieldChange: `${eventPrefix}.element_change_event`,
    clickEvent: 'click-event',
    elementChange: `${eventPrefix}.element_change_event`,
    domEvent: `${eventPrefix}.element_dom_event`,
    journeyStart: `${eventPrefix}.journey_start_event`,
    journeyRecord: `${eventPrefix}.journey_record_event`,
    journeyComplete: `${eventPrefix}.journey_complete_event`,
    pageView: `${eventPrefix}.page_view_event`,
};
// export type PassiveEvents = keyof PassiveEventsDefinition;



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/types/event-types.js
// module id = ./node_modules/@celine/passive-tracking/dist/types/event-types.js
// module chunks = 0